import { render } from "./UploadCard.vue?vue&type=template&id=542a134c"
import script from "./UploadCard.vue?vue&type=script&lang=ts"
export * from "./UploadCard.vue?vue&type=script&lang=ts"

import "./UploadCard.vue?vue&type=style&index=0&id=542a134c&lang=scss"
script.render = render

export default script